import { alpha, Box, ButtonBase, Chip, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  getAssignmentLabel,
  getSiteAccent,
  SLOT_STATUS_META,
} from "../../pages/trainer/trainerUtils";

export default function TrainerSlotCard({ slot, compact = false, onClick }) {
  const theme = useTheme();
  const meta = SLOT_STATUS_META[slot.status];
  const accent = slot.siteAccent || getSiteAccent(0);

  return (
    <ButtonBase
      onClick={() => onClick(slot)}
      sx={{
        display: "block",
        width: "100%",
        textAlign: "left",
        borderRadius: 2.5,
        overflow: "hidden",
        border: "1px solid",
        borderColor: meta.border,
        backgroundColor: meta.bg,
        transition: "transform 0.12s, box-shadow 0.12s",
        "&:hover": {
          transform: "translateY(-1px)",
          boxShadow: `0 4px 12px ${alpha(theme.palette.text.primary, 0.08)}`,
        },
        "&:active": { transform: "scale(0.985)" },
      }}
    >
      <Stack direction="row" sx={{ minHeight: compact ? 56 : 68 }}>
        <Box sx={{ width: 5, flexShrink: 0, backgroundColor: accent.text }} />

        <Stack
          spacing={0.4}
          sx={{ flex: 1, minWidth: 0, px: 1.5, py: compact ? 0.75 : 1 }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography
              variant={compact ? "caption" : "body2"}
              sx={{ fontWeight: 700, letterSpacing: 0.2 }}
            >
              {slot.session.start} – {slot.session.end}
            </Typography>
            <Chip
              size="small"
              label={meta.label}
              sx={{
                height: 20,
                fontSize: "0.68rem",
                fontWeight: 700,
                backgroundColor: meta.border,
                color: "#fff",
                "& .MuiChip-label": { px: 0.8 },
              }}
            />
          </Stack>

          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              lineHeight: 1.3,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {slot.session.title || "Training"}
          </Typography>

          <Stack direction="row" spacing={0.5} alignItems="center">
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: accent.text,
                flexShrink: 0,
              }}
            />
            <Typography variant="caption" color="text.secondary" noWrap>
              {slot.siteName}
              {slot.assignment
                ? ` · ${getAssignmentLabel(slot.assignment)}`
                : " · Frei"}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </ButtonBase>
  );
}
